<div class="card card-custom">
  <div class="card-header">
    <div *ngIf="data.length > 1" class="card-title mr-0 w-50" style="padding-right: 2.25rem">
      <h3 class="card-label overflow-hidden mr-0">
        <span class="label label-xl label-inline label-light-warning mr-3" style="width: 70px"
          >Before</span
        >{{ data[1].name | titlecase }}
      </h3>
    </div>
    <div
      class="card-title mr-0"
      [ngStyle]="{
        width: data.length > 1 ? '50%' : '100%',
        paddingLeft: data.length > 1 ? '2.25rem' : 0
      }"
    >
      <h3 class="card-label overflow-hidden mr-0">
        <span
          *ngIf="data.length > 1"
          class="label label-xl label-inline label-light-success mr-3"
          style="width: 70px"
          >After</span
        >{{ data[0].name | titlecase }}
      </h3>
    </div>
  </div>
  <div
    class="card-body d-flex align-items-stretch my-5 p-0"
    [ngClass]="{
      'justify-content-between': data.length > 1,
      'justify-content-center': data.length <= 1
    }"
  >
    <div *ngIf="data[0].status === 'cancel'; then cancel; else other"></div>
    <ng-template #cancel>
      <div style="width: 100%; padding: 2.25rem">
        <label>{{ 'WORKFLOW.CANCEL_REASON' | translate }}</label>
        <textarea
          class="text-muted w-100 p-4"
          rows="5"
          [value]="data[0].cancel_reason"
          [disabled]="true"
        ></textarea>
      </div>
    </ng-template>
    <ng-template #other>
      <div
        *ngIf="data.length > 1"
        class="scroll card-body w-50"
        style="border-right: 1px solid #ebedf3"
        [perfectScrollbar]="{ wheelPropagation: false }"
      >
        <formio
          [form]="data[1].form_schema"
          [submission]="data[1].input_data"
          [readOnly]="true"
        ></formio>
      </div>
      <div
        class="scroll card-body"
        [style.width]="data.length > 1 ? '50%' : '100%'"
        [perfectScrollbar]="{ wheelPropagation: false }"
      >
        <formio
          [form]="data[0].form_schema"
          [submission]="data[0].input_data"
          [readOnly]="true"
        ></formio>
      </div>
    </ng-template>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button type="button" mat-raised-button (click)="close()">
      <span translate="GLOBAL.CLOSE">Close</span>
    </button>
  </div>
</div>
